import * as React from 'react';
import { Redirect, withRouter } from "react-router-dom";
import AuthService from '../../services/authService';
import { Menubar } from 'primereact/menubar';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import Translate from '../../common/functions/translate';

interface Iprops {
  history: any;
  lang: string;
  isUserLogged: boolean;
  onUserLogout: any;
}

interface IState {
  activeMenuUrl: string;
  isVisibleConfirmDialog: boolean;
}

class Navigation extends React.Component<Iprops, IState> {
  authService = new AuthService();
  redirect: boolean = false;


  constructor(props) {
    super(props);
    this.state = {
      activeMenuUrl: '',
      isVisibleConfirmDialog: false
    }
  }


  onLogoutClick = () => {
    this.setState({
      isVisibleConfirmDialog: true
    });
  }

  logoutConfirmClick = () => {
    this.setState({ isVisibleConfirmDialog: false }, () => {
      this.authService.logout()
      this.props.onUserLogout()
      this.props.history.replace('login');
    })
  }

  handleMenuItemClick = (menuUrl) => {
    this.redirect = true;
    this.props.history.push(menuUrl);
    this.setState({ activeMenuUrl: menuUrl });
  }

  render() {
    const { activeMenuUrl } = this.state;

    let menuItems: any = [{
      label: Translate('Home'),
      command: () => { this.handleMenuItemClick('/') }
    }];

    if (this.authService.checkIsAdmin()) {
      menuItems.push(
        {
          label: Translate('Users'),
          command: () => { this.handleMenuItemClick('/users') }
        },
        {
          label: Translate('Articles'),
          command: () => { this.handleMenuItemClick('/products') }
        },
        {
          label: Translate('Offers'),
          command: () => { this.handleMenuItemClick('/offers') }
        },
        {
          label: Translate('Configuration'),
          items: [
            {
              label: Translate('Regions'),
              command: () => { this.handleMenuItemClick('/configuration/regions') }
            },
            {
              label: Translate('Categories'),
              command: () => { this.handleMenuItemClick('/configuration/categories') }
            }
          ]
        },
        {
          label: Translate("System"),
          items: [
            {
              label: Translate('Logs'),
              command: () => { this.handleMenuItemClick('/system/logs') }
            }]
        }
      )
    }

    if (this.authService.checkIsProductManager()) {
      menuItems.push(
        {
          label: Translate('Articles'),
          command: () => { this.handleMenuItemClick('/products') }
        }
      )
    }

    if (this.authService.checkIsRegionalManager() || this.authService.checkIsTrader()) {
      menuItems.push({
        label: Translate('Offers'),
        command: () => { this.handleMenuItemClick('/offers') }
      })
    }


    if (this.redirect) {
      this.redirect = false;
      return <Redirect to={activeMenuUrl} />;
    }
    return (
      <>
        {this.authService.isAuthenticated() ?
          <div>
            <Menubar model={menuItems}>
            </Menubar>
          </div> : null
        }

        {this.state.isVisibleConfirmDialog ?
          <ConfirmDialog
            headerTitle={Translate("Logout")}
            isVisible={this.state.isVisibleConfirmDialog}
            yesClick={this.logoutConfirmClick}
            noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
            {Translate("Are you sure you want to logout")}
          </ConfirmDialog>
          : null}

      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang,
    isUserLogged: state.common.isUserLogged
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT })
  }
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(Navigation));